import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';
import { TrackingFeature } from '../+state';
import { ApiTypes } from '../..';
import {
    DataLayer,
    DataLayerEntry,
    TrackingElementType,
    TrackingEvent,
    TrackingPageElementStatusType,
} from '../utilities/tracking';

declare global {
    interface Window {
        dataLayer: DataLayer;
    }
}

@Injectable({
    providedIn: 'root',
})
export class EventTrackingService {
    protected readonly store = inject(Store);
    protected readonly platformId: object = inject(PLATFORM_ID);
    protected readonly dataLayerPushs$ = new ReplaySubject<DataLayerEntry>();
    protected logs = false;

    init(logs: boolean): void {
        this.logs = logs;
        this.dataLayerPushs$.pipe(takeUntilDestroyed()).subscribe((pushObject) => {
            this.getDataLayer().push(pushObject);
        });
    }

    protected getDataLayer(): DataLayer {
        if (isPlatformServer(this.platformId)) {
            return [];
        }
        if (!window.dataLayer) {
            window.dataLayer = [];
        }
        return window.dataLayer;
    }

    public pushDataLayer(dataLayer: DataLayerEntry): void {
        this.dataLayerPushs$.next(dataLayer);
        if (this.logs) {
            // eslint-disable-next-line no-console
            console.log('📈 pushDataLayer', dataLayer);
        }
    }

    trackButton(tracking: {
        elType: TrackingElementType;
        event: TrackingEvent;
        elLabel?: string;
        elTarget?: string;
        vehicle?: ApiTypes.VehicleDetail;
        status?: TrackingPageElementStatusType;
    }): void {
        this.store.dispatch(
            TrackingFeature.actions.clickTracking({
                elType: tracking.elType,
                elLabel: tracking.elLabel,
                elTarget: tracking.elTarget,
                event: tracking.event,
                vehicle: tracking.vehicle,
                status: tracking.status,
            }),
        );
    }
}
